import MainTab from "new/component/mainTab";
import ProfileCard from "new/component/ProfileCard";
import { useState } from "react";

const Home = () => {
  return (
    <div className="home-screen">
      <ProfileCard />
      <MainTab />
    </div>
  );
};

export default Home;
